module.exports = __webpack_public_path__ + "media/registry-cover_1200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/registry-cover_1200.jpg
// module id = 27
// module chunks = 0